import api from './index';
//
let exports = {};

//
exports.getGoodsCatBrandList = function (params, callback) {// 获取分类品牌列表
    api.post('/goods/categ/brand/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getGoodsCatListForMsgSubscr = function (params, callback) {// 获取商品分类列表
    api.post('/goods/categ/list/get/for/msg/subscr')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatList = function (params, callback) {// 获取商品分类列表
    api.post('/goods/categ/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatTreeList = function (params, callback) {// 查询商品分类树列表
    api.post('/goods/categ/tree/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询商品分类树列表
exports.getGoodsCatTreeListByFilter = function (params, callback) {
    api.post('/goods/categ/tree/list/get/by/filter')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodCat = function (params, callback) {// 获取商品分类信息
    api.post('/goods/categ/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 根据parentId获取商品分类列表
exports.getGoodsCatListByParentId = function (params, callback) {
    api.post('/goods/categ/list/get/by/parentId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//
exports.getGoodsCatAttrList = function (params, callback) {// 条件查询商品分类属性列表
    api.post('/goods/categ/attr/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getGoodsCatAttrListByCatId = function (params, callback) {// 获取分类属性及属性项列表
    api.post('/goods/categ/attr/list/get/by/catId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getGoodsCatAttr = function (params, callback) {// 获取商品分类属性信息
    api.post('/goods/categ/attr/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveGoodsCatAttr = function (params, callback) {// 保存商品分类属性信息
    api.post('/goods/categ/attr/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.deleteGoodsCatAttr = function (params, callback) {// 删除商品分类属性信息
    api.post('/goods/categ/attr/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getGoodsCatAttrOptionList = function (params, callback) {// 获取商品分类属性项列表
    api.post('/goods/categ/attr/option/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getGoodsCatAttrOption = function (params, callback) {// 获取商品分类属性项信息
    api.post('/goods/categ/attr/option/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveGoodsCatAttrOption = function (params, callback) {// 保存商品分类属性项信息
    api.post('/goods/categ/attr/option/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
}

exports.deleteGoodsCatAttrOption = function (params, callback) {// 删除商品分类属性项信息
    api.post('/goods/categ/attr/option/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//
exports.getGoodsCatSpecList = function (params, callback) {// 查询商品分类规格列表
    api.post('/goods/categ/spec/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveGoodsCatSpec = function (params, callback) {// 保存商品分类规格信息
    api.post('/goods/categ/spce/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
}

exports.getGoodsCatSpec = function (params, callback) {// 获取商品分类规格信息
    api.post('/goods/categ/spec/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.deleteGoodsCatSpec = function (params, callback) {// 删除商品分类规格信息
    api.post('/goods/categ/spec/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getGoodsCatSpecOptionList = function (params, callback) {// 条件查询商品分类规格项列表
    api.post('/goods/categ/spec/option/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getGoodsCatSpecOption = function (params, callback) {// 获取商品分类规格项信息
    api.post('/goods/categ/spec/option/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveGoodsCatSpecOption = function (params, callback) {// 保存商品分类规格信息
    api.post('/goods/categ/spec/option/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.deleteGoodsCatSpecOption = function (params, callback) {// 删除商品分类规格信息
    api.post('/goods/categ/spec/option/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
}

exports.setGoodsCatPropBelongGroup = function (params, callback) {// 设置属性所属分组
    api.post('/goods/categ/prop/belong/group/set/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getGoodsCatPropGroupList = function (params, callback) {// 获取商品分类_属性分组列表
    api.post('/goods/categ/prop/group/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// ----------------- 商户常用商品分类 ------------------------------
exports.getMerchtFusedGoodsCatList = function (data, callback) {// 查询商户常用商品分类列表
    api.post('/goods/categ/mercht/fused/goods/cat/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchtFusedGoodsCatPageList = function (data, callback) {// 查询商户常用商品分类列表
    api.post('/goods/categ/mercht/fused/goods/cat/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchtFusedGoodsCatById = function (params, callback) {// 查询商户常用商品分类
    api.get('/goods/categ/mercht/fused/goods/cat/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
exports.saveMerchtFusedGoodsCat = function (data, callback) {// 保存商户常用商品分类
    api.post('/goods/categ/mercht/fused/goods/cat/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteMerchtFusedGoodsCat = function (data, callback) {// 删除商户常用商品分类
    api.post('/goods/categ/mercht/fused/goods/cat/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.moveMerchtFusedServcCat = function (data, callback) {// 删除商户常用商品分类
    api.post('/goods/categ/mercht/fused/servc/cat/move/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchtFusedGoodsCatListByMerchantId = function (data, callback) {// 查询商户常用服务分类
    api.post('/goods/categ/mercht/fused/goods/cat/list/get/by/merchantId')
    .data(data)
    .done(callback)
    .go();
};

// =================== 商品分类设备分组 ==========================

// 获取零售商商品分类设备分组列表-同步方法
exports.getRetailerGoodsCatDevcGroupListForSync = function (data, callback) {
    api.get('/goods/categ/retailer/goods/cat/devc/group/list/sync/get')
    .sync(true)
    .params(data)
    .done(callback)
    .go();
};

// ================== 个人资质-对服务商的人员资质要求 ======================

exports.getStaffQualiClaimToServicerPageList = function (postData, callback) {// 对服务商的人员资质要求-分页列表
    api.post('/goods/categ/staff/quali/claim/to/servicer/page/list')
    .data(postData)
    .done(callback)
    .go();
};

exports.getStaffQualiClaimToServicerList = function (postData, callback) {// 对服务商的人员资质要求-列表
    api.post('/goods/categ/staff/quali/claim/to/servicer/list')
    .data(postData)
    .done(callback)
    .go();
};

exports.saveStaffQualiClaimToServicer = function (postData, callback) {// 对服务商的人员资质要求-新增
    api.post('/goods/categ/staff/quali/claim/to/servicer/save/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.updateStaffQualiClaimToServicer = function (data, callback) {// 对服务商的人员资质要求-修改
    api.post('/goods/categ/staff/quali/claim/to/servicer/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteStaffQualiClaimToServicer = function (params, callback) {// 对服务商的人员资质要求-删除
    api.post('/goods/categ/staff/quali/claim/to/servicer/delete/do')
    .params(params)
    .done(callback)
    .go();
};
exports.getStaffQualiClaimToServicerServcTypeId = function (data, callback) {// 对服务商的人员资质要求-删除
    api.post('/goods/categ/staff/quali/claim/to/servicer/get/servcTypeId')
    .data(data)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsCateg.js
// module id = 26
// module chunks = 1